import { Col, Row } from '@/components/grid/grid-component';
import styled from 'styled-components';

const Spacer = styled.div`
  padding: ${(props) => (props.noPadding ? '0px' : '16px')};
`;

const StyledRow = styled.div`
  display: flex;
  flex-direction: row;
`;

const InfoModalImageContainer = styled.div`
  width: 50%;
`;

const InfoModalImage = styled.img`
  width: 100%;
  margin: 0 auto;
`;

const Header = styled.div`
  display: flex;
`;

const HeaderCol = styled(Col)`
  height: 59px;
  display: flex;
  align-items: center;
`;

const HeaderRow = styled(Row)`
  margin: 0px !important;
`;

const GreyLine = styled.div`
  display: flex;
  width: 100%;
  height: 1px;
  background-color: ${({ theme }) => theme.COLOR_GREY5};
  margin-top: auto;
`;

const CarouselContainer = styled.div`
  margin-top: 16px;
  min-height: 40vh;
  display: ${(props) => (props.isInModal ? 'contents' : 'initial')};
  width: ${(props) => (props.isInModal ? '800px' : 'initial')};

  position: ${(props) => (props.isInModal ? 'fixed' : 'sticky')};
  top: 0;
  z-index: 10; /* Adjust z-index if needed */

  img {
    border-radius: 8px;

    width: ${(props) => (props.isInModal ? '100%' : 'auto')};
    /* min-height: ${(props) => (props.isInModal ? '360px' : 'initial')}; */
    height: auto; /* Maintains aspect ratio */
    object-fit: contain;
    object-position: center center;
  }

  .image-gallery {
    width: 100%;
    height: auto; /* Adjusts height based on content */
    /* min-height: ${(props) => (props.isInModal ? '360px' : 'initial')}; */
  }

  .image-gallery-content .image-gallery-slide .image-gallery-image {
    /* min-height: ${(props) => (props.isInModal ? '360px' : 'initial')}; */
  }

  iframe {
    border: ${(props) => (props.isInModal ? 'none' : 'initial')};
  }

  .image-gallery-thumbnail {
    width: ${(props) => (props.isInModal ? '144px' : 'initial')};
    vertical-align: middle;
    object-fit: contain;
    object-position: center center;
  }

  .image-gallery-thumbnail .image-gallery-thumbnail-image {
    vertical-align: middle;
    line-height: 0;
    object-fit: contain;
    object-position: center center;
    min-height: unset !important;
  }

  .image-gallery-thumbnail .image-gallery-thumbnail-inner {
    display: flex;
    position: relative;
    height: 100%;
    width: 100%;
  }

  .image-gallery-thumbnail {
    div {
      iframe {
        border-radius: 12px;
      }
    }
  }
`;

const DescriptionContainer = styled.div`
  margin: 0px 10px;
`;

const WrapperContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  overflow-y: hidden;
  padding: 0;
`;

const StyledSummary = {
  Spacer,
  StyledRow,
  InfoModalImageContainer,
  InfoModalImage,
  Header,
  HeaderCol,
  HeaderRow,
  GreyLine,
  CarouselContainer,
  DescriptionContainer,
  WrapperContainer,
};

export default StyledSummary;
